module.exports = __webpack_public_path__ + "static/media/search-subject-img1.0c66b0f4.jpg";